import * as Connector from 'shared/connectors/userConnector';
import { USER } from 'store/types';

const init = () => ({
  type: USER.GET_USERS_AMOUNT_INIT,
});

export const success = data => ({
  type: USER.GET_USERS_AMOUNT_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: USER.GET_USERS_AMOUNT_FAILURE,
});

const getUsersAmount = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getUsersAmount();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getUsersAmount;
